var LegendsMode;
(function (LegendsMode) {
    LegendsMode["INLINE"] = "inline";
    LegendsMode["POPOVER"] = "popover";
})(LegendsMode || (LegendsMode = {}));
var LegendsSize;
(function (LegendsSize) {
    LegendsSize["LARGE"] = "large";
    LegendsSize["NORMAL"] = "normal";
})(LegendsSize || (LegendsSize = {}));
export { LegendsMode, LegendsSize, };
//# sourceMappingURL=legends-constants.js.map